@if (product() || singleProduct()) {
    <div class="ca-product-card flex flex-col">
        <ng-container *ngTemplateOutlet="cardContent"></ng-container>
    </div>
} @else if (!productId()) {
    <div class="ca-product-card flex justify-center items-center gap-6">
        <ng-container *ngTemplateOutlet="emptyCard"></ng-container>
    </div>
} @else if (productsService.loading()) {
    <div class="ca-product-card flex justify-center items-center gap-6">
        <ca-spinner
            data-testid="loading-devices-spinner"
            [transparent]="true"
            [small]="true"
            [text]="'PRODUCT_CARD.LOADING' | translate"
        ></ca-spinner>
    </div>
} @else if (productsService.error()) {
    <div class="ca-product-card flex flex-col justify-center items-center p-4 md:p-6 gap-3 md:gap-4">
        <div class="ca-headline-5">{{ 'PRODUCT_CARD.ERROR' | translate }}</div>
        <div class="ca-text-md ca-text-tertiary">{{ 'PRODUCT_CARD.ERROR_DESCRIPTION' | translate }}</div>
        <div>
            <button mat-button class="ca-button ca-button-s" (click)="readProduct()">
                <ca-icon icon="update" class="ca-icon-s-16-p-0-f-16"></ca-icon>
                <span class="underline">{{ 'CA.BUTTON.TRY_AGAIN' | translate }}</span>
            </button>
        </div>
    </div>
}

<ng-template #emptyCard>
    <div class="flex flex-col justify-center items-center p-4 md:p-6 gap-4">
        <div class="ca-text-md ca-text-tertiary">
            {{ noProductText() | translate }}
        </div>
        <ca-product-picker
            [countryCode]="countryCode()"
            [languageCode]="languageCode()"
            [productType]="productType()"
            [allowedProductTypes]="allowedProductTypes()"
            [allowDifferentProductTypeSelection]="allowDifferentProductTypeSelection()"
            [buttonText]="showAllProductsButtonText()"
            [headerText]="productPickerHeaderText()"
            (selected)="onProductSelected($event)"
        >
        </ca-product-picker>
    </div>
</ng-template>

<ng-template #cardContent>
    @if (product() || singleProduct(); as product) {
        <div class="ca-product-card-image flex justify-center items-center">
            <img [src]="product.pictureUrl || placeholderImageSrc" />
            <div class="ca-product-card-action flex justify-between items-center gap-2">
                <button
                    mat-icon-button
                    class="ca-card-delete ca-button ca-button-s push-icon-right"
                    data-testid="delete-product-btn"
                    [caConfirm]="{
                        title:
                            'CONFIRM_DIALOG.DELETE_PRODUCT.TITLE'
                            | translate: { productName: product.productShortName || product.productName },
                        content:
                            'CONFIRM_DIALOG.DELETE_PRODUCT.CONTENT'
                            | translate: { productName: product.productShortName || product.productName },
                        confirmBtn: 'CA.BUTTON.DELETE' | translate,
                        cancelBtn: 'CA.BUTTON.CANCEL' | translate
                    }"
                    (confirm)="onProductRemoved()"
                >
                    <ca-icon icon="trash" class="ca-icon-s-16-p-0-f-16"></ca-icon>
                </button>
                <!-- TODO: Uncomment when API ready -->
                <!-- <ca-tag type="green" [rounded]="true">
                {{ 'CA.LABEL.RECOMMENDED' | translate }}
            </ca-tag> -->
            </div>
        </div>
        <div class="ca-product-card-content flex-1 flex justify-between flex-col p-4 gap-4">
            <div class="flex flex-col gap-4">
                <div class="ca-text-sm ca-text-tertiary">
                    {{ 'CA.DEVICE_TYPE.' + product.productType | translate }}
                </div>
                <h6 class="flex items-center gap-2 m-0">
                    <div class="ca-badge ca-text-sm fw-semibold">{{ product.quantity }}x</div>
                    <div class="ca-headline-6">{{ product.productName }}</div>
                </h6>
                <ng-content></ng-content>
                <div class="ca-product-card-specs flex flex-col">
                    @for (spec of product | caProductTechnicalData; track spec.name) {
                        <div class="ca-product-card-spec flex justify-between py-2 gap-2">
                            <div class="ca-text-md ca-text-tertiary">{{ spec.name | translate }}</div>
                            <div class="ca-text-md">
                                {{ spec.value ?? '-' }}
                                @if (spec.unit) {
                                    <span>
                                        {{ spec.unit | translate }}
                                    </span>
                                }
                            </div>
                        </div>
                    }
                </div>
            </div>
            <div class="flex flex-col gap-4">
                <div class="ca-product-card-price ca-headline-5">{{ product.price | caCurrency: countryCode() : languageCode() }}</div>
                <div class="flex justify-end py-2">
                    <ca-product-picker
                        [countryCode]="countryCode()"
                        [languageCode]="languageCode()"
                        [productType]="product.productType"
                        [allowedProductTypes]="allowedProductTypes()"
                        [allowDifferentProductTypeSelection]="allowDifferentProductTypeSelection()"
                        [headerText]="productPickerHeaderText()"
                        [asCustomButton]="true"
                        (selected)="onProductSelected($event)"
                    >
                        <button
                            custom-button
                            data-testid="change-selection-button"
                            mat-stroked-button
                            [disableRipple]="true"
                            class="ca-button-link ca-button-no-padding ca-button-text-underline ms-auto mt-auto"
                        >
                            <span>{{ 'CA.BUTTON.CHANGE_SELECTION' | translate }}</span>
                            <ca-icon class="ca-icon-s-16-p-0-f-16" icon="chevron-right"></ca-icon>
                        </button>
                    </ca-product-picker>
                </div>
            </div>
        </div>
    }
</ng-template>
